import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/media/icons/duotone/Text/Filter.svg'
import _imports_1 from '@/assets/media/icons/duotone/Communication/Share.svg'
import _imports_2 from '@/assets/media/icons/duotone/Design/Edit.svg'
import _imports_3 from '@/assets/media/icons/duotone/Layout/Layout-grid.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-c81bbf5c")

_pushScopeId("data-v-c81bbf5c")
const _hoisted_1 = { class: "fs-2" }
const _hoisted_2 = { class: "fs text-gray-600" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "fas fa-download" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_6 = {
  href: "#",
  class: "btn btn-sm btn-flex btn-light btn-active-primary fw-bolder",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_7 = { class: "svg-icon svg-icon-5 svg-icon-gray-500 me-1" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Filter ")
const _hoisted_9 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_10 = { class: "d-block fw-bolder mb-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Payment Reference ")
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fas fa-link" }, null, -1)
const _hoisted_13 = { class: "mb-1 fs-7" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "fas fa-compass me-2" }, null, -1)
const _hoisted_15 = { class: "mb-1 fs-7" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-desktop me-2" }, null, -1)
const _hoisted_17 = { class: "svg-icon svg-icon-4" }
const _hoisted_18 = { class: "svg-icon svg-icon-4" }
const _hoisted_19 = { class: "svg-icon svg-icon-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "Are you sure you want to submit update?", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = { class: "dialog-footer" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Confirm ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_FilterInvocation = _resolveComponent("FilterInvocation")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_pagination = _resolveComponent("pagination")
  const _component_table_skeleton = _resolveComponent("table-skeleton")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_el_card, null, {
      default: _withId(() => [
        _createVNode(_component_el_row, { class: "d-flex align-items-center mb-8" }, {
          default: _withId(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t("invocation.title")), 1),
                _createVNode(_component_el_row, { class: "d-flex justify-content-between" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("invocation.subtitle")), 1),
                    _createVNode("div", _hoisted_3, [
                      _createVNode("a", {
                        class: "btn btn-sm btn-flex btn-success fw-bolder me-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download('Invocation-list')))
                      }, [
                        _hoisted_4,
                        _hoisted_5
                      ]),
                      _createVNode("a", _hoisted_6, [
                        _createVNode("span", _hoisted_7, [
                          _createVNode(_component_inline_svg, { src: _imports_0 })
                        ]),
                        _hoisted_8
                      ]),
                      _createVNode(_component_FilterInvocation, { onFiltered: _ctx.filtered }, null, 8, ["onFiltered"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_table_skeleton, {
          loading: !_ctx.data || _ctx.isValidating
        }, {
          default: _withId(() => [
            _withDirectives(_createVNode(_component_el_table, {
              class: "Invocation-table mt-8 fs-7",
              data: _ctx.data?.data,
              style: {"width":"100%"}
            }, {
              default: _withId(() => [
                _createVNode(_component_el_table_column, { type: "expand" }, {
                  default: _withId((scope) => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode(_component_el_descriptions, {
                        size: "small",
                        column: "3",
                        border: ""
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_descriptions_item, { label: "ID" }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(scope.row.id), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, { label: "VA Number" }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(scope.row.va_number), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, { label: "Payment" }, {
                            default: _withId(() => [
                              _createVNode("span", _hoisted_10, [
                                _createVNode("a", {
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.gotoPayment(scope.row.id)), ["prevent"])
                                }, [
                                  _hoisted_11,
                                  _hoisted_12
                                ], 8, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_descriptions, {
                        size: "small",
                        column: "1",
                        class: "mt-8",
                        direction: "vertical",
                        border: ""
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_descriptions_item, {
                            label: "Outbound Response",
                            width: "50px"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(scope.row.outbound_response), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_descriptions_item, {
                            label: "Failed Message",
                            width: "50px"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(scope.row.failed_msg), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  prop: "ref_id",
                  label: _ctx.$t('invocation.ref_id')
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.ref_id), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "center",
                  prop: "type",
                  label: _ctx.$t('invocation.type')
                }, {
                  default: _withId((scope) => [
                    _createVNode(_component_el_tag, {
                      type: scope.row.type == 'inq' ? 'warning' :
                scope.row.type == 'pay' ? 'success' :
                  scope.row.type == 'rev' ? 'danger' :
                    scope.row.type == 'trf' ? 'info' :
                      'primary',
                      effect: "plain",
                      size: "small"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(scope.row.type.toUpperCase()), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  width: "100px",
                  prop: "status",
                  label: _ctx.$t('invocation.status')
                }, {
                  default: _withId((scope) => [
                    _createVNode("span", {
                      class: 'badge ' + (
                scope.row.status == 'success' ? 'badge-light-success' :
                  scope.row.status == 'failed' ? 'badge-light-danger' :
                    scope.row.status == 'suspect' ? 'badge-light-dark' : 'badge-light-warning')
                    }, _toDisplayString(scope.row.status.toUpperCase()), 3)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  prop: "institution_name",
                  label: _ctx.$t('invocation.institution_name')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "center",
                  prop: "bcn",
                  label: _ctx.$t('invocation.bcn')
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.va_number.substring(0, 6)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "right",
                  prop: "fqva",
                  label: _ctx.$t('invocation.fqva'),
                  width: "140"
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.va_number), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "left",
                  prop: "channel",
                  label: _ctx.$t('invocation.channel')
                }, {
                  default: _withId((scope) => [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Channel Name",
                      placement: "top-start"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createTextVNode(" " + _toDisplayString(scope.row.channel), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: "Payment Terminal",
                      placement: "top-start"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(scope.row.payment_terminal), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "center",
                  prop: "gateway",
                  label: _ctx.$t('invocation.gateway')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "right",
                  prop: "amount",
                  label: "Bill Amount"
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.numberFormat(scope.row.bill_amount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "right",
                  prop: "amount",
                  label: _ctx.$t('invocation.amount')
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.numberFormat(scope.row.amount.toString())), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  prop: "created_at",
                  label: _ctx.$t('invocation.created_at')
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.moment(scope.row.created_at).add(_ctx.moment(scope.row.created_at).utcOffset(),
                  'minute').format('YYYY-MM-DD HH:mm:ss')), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  align: "center",
                  prop: "et",
                  label: "ET",
                  width: "60"
                }, {
                  default: _withId((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.elapsedTime(scope.row.elapsed_time)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  "header-align": "center",
                  align: "right",
                  label: _ctx.$t('invocation.action')
                }, {
                  default: _withId((scope) => [
                    (scope.row.status == 'suspect' && _ctx.checkPermission('invocation-retry').isGranted)
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 0,
                          class: "box-item",
                          effect: "dark",
                          content: "Retry Transaction",
                          placement: "bottom"
                        }, {
                          default: _withId(() => [
                            _createVNode("a", {
                              class: "btn btn-sm btn-icon btn-success mt-2 me-2",
                              onClick: ($event: any) => (_ctx.showDialog(scope.row.id))
                            }, [
                              _createVNode("span", _hoisted_17, [
                                _createVNode(_component_inline_svg, { src: _imports_1 })
                              ])
                            ], 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (_ctx.checkPermission('invocation-update').isGranted)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/app/invocation/${scope.row.id}/edit`,
                          custom: ""
                        }, {
                          default: _withId(({ href, navigate }) => [
                            _createVNode(_component_el_tooltip, {
                              class: "box-item",
                              effect: "dark",
                              content: "Edit Invocation",
                              placement: "left"
                            }, {
                              default: _withId(() => [
                                _withDirectives(_createVNode("a", {
                                  class: "btn btn-sm btn-icon btn-warning mt-2",
                                  href: href,
                                  onClick: navigate
                                }, [
                                  _createVNode("span", _hoisted_18, [
                                    _createVNode(_component_inline_svg, { src: _imports_2 })
                                  ])
                                ], 8, ["href", "onClick"]), [
                                  [_vShow, _ctx.isEditable(scope)]
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true),
                    (_ctx.checkPermission('invocation-detail').isGranted)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 2,
                          to: `/app/invocation/${scope.row.id}/detail/bill`,
                          custom: ""
                        }, {
                          default: _withId(({ href, navigate }) => [
                            _createVNode(_component_el_tooltip, {
                              class: "box-item",
                              effect: "dark",
                              content: "Detail Invocation",
                              placement: "bottom"
                            }, {
                              default: _withId(() => [
                                _createVNode("a", {
                                  class: "btn btn-sm btn-icon btn-info mt-2 ms-2",
                                  href: href,
                                  onClick: navigate
                                }, [
                                  _createVNode("span", _hoisted_19, [
                                    _createVNode(_component_inline_svg, { src: _imports_3 })
                                  ])
                                ], 8, ["href", "onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"]), [
              [_directive_loading, _ctx.isDownloading]
            ]),
            (_ctx.data && _ctx.data.current_page)
              ? (_openBlock(), _createBlock(_component_pagination, {
                  key: 0,
                  onChange: _ctx.handleChangePage,
                  ref: "paginationRef",
                  class: "mt-8",
                  "hide-when-only-one-page": true,
                  page: _ctx.data.current_page,
                  "per-page": _ctx.data.per_page ?? 0,
                  "total-current-page-item": _ctx.data.data.length,
                  "total-all-items": _ctx.data.total ?? 0
                }, null, 8, ["onChange", "page", "per-page", "total-current-page-item", "total-all-items"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogVisible = $event)),
      title: "Confirmation",
      width: "30%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.retryTransaction
          }, {
            default: _withId(() => [
              _hoisted_24
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _hoisted_20,
        _hoisted_21
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})